import { motion } from "framer-motion";
import { Award, ShieldCheck, BadgeCheck, FileBadge2, Building2, HardHat, Plane, Factory } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const ICONS = [Award, ShieldCheck, BadgeCheck, FileBadge2, HardHat, Building2, Factory, Plane];

export default function Certifications() {
  const { t } = useI18n();
  const c = t.certifications;

  return (
    <section
      id="certifications"
      className="relative bg-background"
      data-testid="certifications-section"
    >
      <div className="container-page section-y">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <span className="overline">{c.eyebrow}</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.05]">
              {c.heading1} <span className="text-primary">{c.heading1Accent}</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-5 text-muted-foreground leading-relaxed"
          >
            {c.description}
          </motion.p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-px bg-border border border-border">
          {c.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={item.code}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: i * 0.05 }}
                className="group relative bg-background p-6 md:p-7 hover:bg-secondary hover:text-secondary-foreground transition-colors duration-500 overflow-hidden"
                data-testid={`certification-${i}`}
              >
                <div className="absolute -top-6 -end-6 opacity-[0.05] group-hover:opacity-20 transition-opacity duration-500">
                  <Icon className="h-28 w-28" />
                </div>
                <div className="relative">
                  <div className="w-11 h-11 grid place-items-center border border-border group-hover:border-primary transition-colors">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <div className="mt-5 text-xs uppercase tracking-[0.22em] text-primary font-bold">
                    {item.code}
                  </div>
                  <div className="mt-2 text-base md:text-lg font-bold leading-tight">
                    {item.title}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
